<template>
    <div>

        <main role="main">

            <div class="container">

                <div class="row mb-5">

                    <div class="col-md-12">

                        <h2 class="mb-5">
                            <font-awesome-icon icon="home"/>
                            SubPage 2
                        </h2>

                    </div>
                </div>
            </div>

        </main>

    </div>
</template>

<script type="text/javascript">
    import Vue from 'vue';
    import {library} from '@fortawesome/fontawesome-svg-core'
    import {faHome} from '@fortawesome/free-solid-svg-icons'
    import SidebarNavigation from '../components/SidebarNavigation';
    import { VueGoodTable } from 'vue-good-table';
    import axios from 'axios/index';

    library.add(faHome);


    export default {
        name: 'SubPageTwo',
        components: {
            SidebarNavigation
        },
        data() {
            return {

            }

        },
        methods: {}
    };
</script>



// WEBPACK FOOTER //
// src/pages/SubPageTwo.vue